// extracted by mini-css-extract-plugin
module.exports = {"sensorIconAndTextGrouping":"ValueChip_sensorIconAndTextGrouping__1o2J4","sensorTypeText":"ValueChip_sensorTypeText__2tIw7","secondaryText":"ValueChip_secondaryText__gj5aw"};